import { Handle, Position } from '@xyflow/react';
import { GitBranch } from 'lucide-react';

const ConditionNode = ({ data }) => {
  return (
    <div className="bg-white rounded-xl shadow-lg border-2 border-indigo-500 w-64 overflow-hidden">
      <div className="bg-indigo-500 p-2 flex items-center gap-2">
        <GitBranch className="h-4 w-4 text-white" />
        <span className="text-xs font-bold text-white uppercase tracking-wider">
          Condition
        </span>
      </div>
      <div className="p-4">
        <div className="text-sm font-semibold text-gray-900 mb-1">
          If "Yes" then
        </div>
        <div className="text-xs text-gray-500 italic">
          {data.condition || 'Check for variable...'}
        </div>
      </div>
      <div className="flex justify-between px-4 pb-2">
        <div className="relative p-2.5 bg-green-200 border border-gray-200 rounded-xl text-center text-xs font-semibold text-gray-700 shadow-sm">
          Yes
          <Handle
            type="source"
            position={Position.Bottom}
            id="yes"
            className="w-3 h-3 bg-green-500 border-2 border-white"
          />
        </div>
        <div className="relative p-2.5 bg-red-200 border border-gray-200 rounded-xl text-center text-xs font-semibold text-gray-700 shadow-sm">
          No
          <Handle
            type="source"
            position={Position.Bottom}
            id="no"
            className="w-3 h-3 bg-green-500 border-2 border-white"
          />
        </div>
      </div>
      <Handle
        type="target"
        position={Position.Top}
        className="w-3 h-3 bg-gray-300 border-2 border-white"
      />
    </div>
  );
};

export default ConditionNode;
